import Select from "ui-components/Select";
import { useState, useEffect } from "react";
import { IncompleteWorksiteSchema } from "../types";
import { IncompleteWorkflowProps } from "./types";
import { useIntl } from "react-intl";
import GetData from "./data";

export const IncompleteWorkflow = ({
  internalUser,
  setIncompleteWorksiteData,
}: IncompleteWorkflowProps) => {
  const [reason, setReason] = useState<string>();

  const intl = useIntl();
  const { reasonOptions } = GetData(intl.formatMessage);

  useEffect(() => {
    let data = {
      type: "incomplete",
      reason: reason,
    };

    setIncompleteWorksiteData(data as IncompleteWorksiteSchema);
  }, [reason]);

  return (
    <>
      <Select
        label={intl.formatMessage({
          id: "terminate_reason_incomplete_reason_label",
          defaultMessage: "Motivo",
        })}
        options={reasonOptions}
        value={reason}
        onChange={(e) => setReason(e.target.value)}
      />
    </>
  );
};
